import { ProctorRequestStatusLabel, ProctorTypeLabel } from '@exam-center/proctor-management';
import { EllipsisText, Text, type GridColDef } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import type { DraftProctorRequest, InReviewProctorRequest, RejectedProctorRequest } from './types';

export const draftColumns: GridColDef<DraftProctorRequest>[] = [
  {
    field: 'refCode',
    headerName: 'เลขที่คำขอ',
    width: 97,
    sortable: false,
    align: 'center',
    renderCell: ({ row }) => {
      return <Text>{row.refCode ?? '-'}</Text>;
    },
  },
  {
    field: 'name',
    headerName: 'ชื่อผู้คุมสอบ',
    flex: 1,
    sortable: false,
    renderCell: ({ row }) => {
      return <EllipsisText>{row.name}</EllipsisText>;
    },
  },
  {
    field: 'type',
    headerName: 'ประเภทผู้คุมสอบ',
    width: 180,
    sortable: false,
    renderCell: ({ row }) => {
      return <ProctorTypeLabel variant={row.type} />;
    },
  },

  {
    field: 'status',
    headerName: 'สถานะ',
    width: 160,
    sortable: false,
    renderCell: ({ row }) => {
      return <ProctorRequestStatusLabel variant={row.status} />;
    },
  },
  {
    field: 'editedBy',
    headerName: 'ผู้แก้ไขล่าสุด',
    width: 160,
    sortable: false,
    renderCell: ({ row }) => {
      return <EllipsisText>{row.editedBy ?? '-'}</EllipsisText>;
    },
  },
  {
    field: 'editedAt',
    headerName: 'วันที่แก้ไขล่าสุด',
    width: 160,
    renderCell: ({ row }) => {
      return <Text>{formatDateTime(row.editedAt)}</Text>;
    },
  },
];

export const inReviewColumns: GridColDef<InReviewProctorRequest>[] = [
  {
    field: 'refCode',
    headerName: 'เลขที่คำขอ',
    width: 97,
    sortable: false,
    align: 'center',
    renderCell: ({ row }) => {
      return <Text>{row.refCode ?? '-'}</Text>;
    },
  },
  {
    field: 'name',
    headerName: 'ชื่อผู้คุมสอบ',
    flex: 1,
    sortable: false,
    renderCell: ({ row }) => {
      return <EllipsisText>{row.name}</EllipsisText>;
    },
  },
  {
    field: 'type',
    headerName: 'ประเภทผู้คุมสอบ',
    width: 180,
    sortable: false,
    renderCell: ({ row }) => {
      return <ProctorTypeLabel variant={row.type} />;
    },
  },
  {
    field: 'status',
    headerName: 'สถานะ',
    width: 160,
    sortable: false,
    renderCell: ({ row }) => {
      return <ProctorRequestStatusLabel variant={row.status} />;
    },
  },
  {
    field: 'requestedAt',
    headerName: 'วันที่ส่งคำขอ',
    width: 160,
    renderCell: ({ row }) => {
      return <Text>{formatDateTime(row.requestedAt)}</Text>;
    },
  },
];

export const rejectedColumns: GridColDef<RejectedProctorRequest>[] = [
  {
    field: 'refCode',
    headerName: 'เลขที่คำขอ',
    width: 97,
    sortable: false,
    align: 'center',
    renderCell: ({ row }) => {
      return <Text>{row.refCode ?? '-'}</Text>;
    },
  },
  {
    field: 'name',
    headerName: 'ชื่อผู้คุมสอบ',
    flex: 1,
    sortable: false,
    renderCell: ({ row }) => {
      return <EllipsisText>{row.name}</EllipsisText>;
    },
  },
  {
    field: 'type',
    headerName: 'ประเภทผู้คุมสอบ',
    width: 180,
    sortable: false,
    renderCell: ({ row }) => {
      return <ProctorTypeLabel variant={row.type} />;
    },
  },
  {
    field: 'status',
    headerName: 'สถานะ',
    width: 160,
    sortable: false,
    renderCell: ({ row }) => {
      return <ProctorRequestStatusLabel variant={row.status} />;
    },
  },
  {
    field: 'rejectedAt',
    headerName: 'วันที่ไม่อนุมัติ',
    width: 160,
    renderCell: ({ row }) => {
      return <Text>{formatDateTime(row.rejectedAt)}</Text>;
    },
  },
];
